/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Shipments_Status_ReturningInputs */

const vi_vtp_shipments_status_returning = /** @type {(inputs: Vtp_Shipments_Status_ReturningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang hoàn về`)
};

/**

* @param {Vtp_Shipments_Status_ReturningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_shipments_status_returning = /** @type {((inputs?: Vtp_Shipments_Status_ReturningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Shipments_Status_ReturningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_shipments_status_returning(inputs)
});